export default "__VITE_ASSET__BSFcvHqW__"